export enum CardEvents {
  TypeCreated = 'card.card.TypeCreated',
  TagCreated = 'card.card.TagCreated',
  RelationCreated = 'card.card.RelationCreated',
  CardCreated = 'card.card.Created',
  CardOpened = 'card.card.Opened',
  TypeChanged = 'card.card.TypeChanged'
}
